import Link from '../Link';
import { Link as RouterLink } from 'react-router-dom';

export const LinkRoute = props => <Link as={RouterLink} {...props} />;
export default LinkRoute;

export const withLinkRoute = (children, to) => (
  <LinkRoute {...{ to, variant: 'unstyled' }}>{children}</LinkRoute>
);
